import React from 'react';
import Items from '../Items';


interface Props {
    items: object[];
    handleOnClick?: (item: object, isLogin: boolean) => void;
    selectedItems: {
        items: object[],
        visible: boolean,
        isLogin: boolean,
    };
    loginInfo: any;
    isDesktop?: boolean;
}


const Menu: React.FC<Props> = ({
  items,
  selectedItems,
  loginInfo,
  isDesktop,
  handleOnClick,
}) => (
  <div className="menu-container">
    <div id='menu' className={'d-flex pb-1'}>
      <div className='col-2 ps-4 my-auto'>
        <a href='https://www.yettel.rs/' className="logo-link">
          <span className="yettel-bold-font">Yettel.</span>
        </a>
      </div>
      <div className='col-6 text-start d-flex align-items-center'>
        <Items
          isDesktop={isDesktop}
          items={items}
          handleOnClick={handleOnClick}
          cssClasses='list-item second-level'
          isLogin={false}
        />
      </div>
      <div className='col-4 text-end my-auto right-section-menu header-pr'>
        <div className='row'>
          <div className={'col d-flex justify-content-end align-items-center'}>
            <Items
              isDesktop={isDesktop}
              items={loginInfo.item.item.genericLinks}
              handleOnClick={handleOnClick}
              cssClasses='list-item second-level'
              isLogin={true}
            />
          </div>
        </div>
      </div>
    </div>
    {
      selectedItems.visible && (
        <div id='menu-items' className={'secondary-menu-bar'}>
          <div className={selectedItems.isLogin ? 'col-12 text-end pe-5' : 'offset-2 text-start ps-lg-3 ps-1'}>
            <Items
              isDesktop={isDesktop}
              items={selectedItems.items}
              handleOnClick={handleOnClick}
              cssClasses='list-item third-level'
              isLogin={false}
            />
          </div>
        </div>
      )
    }
  </div>
);

export default Menu;
